import React from 'react';
import PropTypes from 'prop-types';

import {Accordion, AccordionDetails, AccordionSummary, Box,
  List, ListItemButton, ListItemText, Tooltip, Typography} from 'views/components';
import {Lock} from 'views/icons';
import {translate} from 'views/module';

const AddWidgetAccordion = (props) => {
  const {
    accordionTitle,
    widgetList,
    expandedAccordion,
    setExpandedAccordion,
    selectedWidgetType,
    setSelectedWidgetType,
  } = props;

  const onAccordionChange = () => {
    setExpandedAccordion((e) => {
      if (e === accordionTitle) {
        return null;
      }
      return accordionTitle;
    });
  };

  return (
    <Accordion
      expanded={expandedAccordion === accordionTitle}
      onChange={onAccordionChange}
      disableGutters
    >
      <AccordionSummary>
        <Typography sx={{textTransform: 'uppercase', fontWeight: 500, color: 'black'}}>
          {accordionTitle}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <List disablePadding>
          {
            widgetList.map((widgetObj) => {
              const widgetType = widgetObj.widgetType;
              const widgetData = widgetObj.widgetData;
              const isLocked = widgetObj.isLocked;

              return (
                <Tooltip
                  key={widgetData.title}
                  title={isLocked ? translate('dashboard.Customization.NoAccess') : ''}
                >
                  <Box>
                    <ListItemButton
                      onClick={() => setSelectedWidgetType(widgetType)}
                      selected={selectedWidgetType === widgetType}
                      disabled={isLocked}
                    >
                      <>
                        <ListItemText
                          primary={translate(widgetData.title)}
                          primaryTypographyProps={{fontWeight: 600}}
                          secondary={ translate(widgetData.description)}
                        />
                        {
                          isLocked &&
                        <Lock/>
                        }
                      </>
                    </ListItemButton>
                  </Box>
                </Tooltip>
              );
            })
          }
        </List>
      </AccordionDetails>
    </Accordion>
  );
};
AddWidgetAccordion.propTypes = {
  accordionTitle: PropTypes.string.isRequired,
  widgetList: PropTypes.array.isRequired,
  expandedAccordion: PropTypes.string,
  setExpandedAccordion: PropTypes.func.isRequired,
  selectedWidgetType: PropTypes.string,
  setSelectedWidgetType: PropTypes.func.isRequired,
};

export default React.memo(AddWidgetAccordion);
